module.exports = __webpack_public_path__ + "img/icon-planner-down.fddc199f.svg";